import * as i0 from '@angular/core';
import { input, Component, ChangeDetectionStrategy, Inject, HostBinding, computed, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@noda-lib/utils/pipes';
import { EqualPipe } from '@noda-lib/utils/pipes';
import * as i2 from '@taiga-ui/kit';
import { TuiBadge, TuiStatus } from '@taiga-ui/kit';
import { ASSETS_CDN_URL } from '@noda-lib/assets/root';
function BadgeComponent_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 1);
  }
}
function BadgeComponent_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "assets-icon", 3);
    i0.ɵɵpipe(1, "equal");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("badge-icon--s", i0.ɵɵpipeBind2(1, 3, ctx_r0.size(), "s"));
    i0.ɵɵproperty("icon", ctx_r0.icon());
  }
}
let IconComponent = /*#__PURE__*/(() => {
  class IconComponent {
    constructor(cdn) {
      this.cdn = cdn;
      this.size = input(null);
      this.icon = input.required();
    }
    get iconSize() {
      return this.size();
    }
    get iconUrl() {
      return `url(${this.cdn}/storage/projects/assets-lib/icons/${this.icon()}.svg)`;
    }
    static {
      this.ɵfac = function IconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IconComponent)(i0.ɵɵdirectiveInject(ASSETS_CDN_URL));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IconComponent,
        selectors: [["assets-icon"]],
        hostVars: 4,
        hostBindings: function IconComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("--assets-icon-component-size", ctx.iconSize, "px")("--assets-icon-url", ctx.iconUrl);
          }
        },
        inputs: {
          size: [1, "size"],
          icon: [1, "icon"]
        },
        decls: 1,
        vars: 0,
        consts: [[1, "assets-icon"]],
        template: function IconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
        },
        styles: ["[_nghost-%COMP%]{--assets-icon-component-size: 24px;display:inline-flex}[position=left][_nghost-%COMP%]{transform:translate(calc(-1 * var(--assets-icon-button-offset, var(--assets-icon-default-button-offset))))}[position=right][_nghost-%COMP%]{transform:translate(var(--assets-icon-button-offset, var(--assets-icon-default-button-offset)))}[_nghost-%COMP%]   .assets-icon[_ngcontent-%COMP%]{width:var(--assets-icon-component-size);height:var(--assets-icon-component-size);background-color:currentcolor;background-size:cover;mask-image:var(--assets-icon-url);mask-position:center;mask-repeat:no-repeat;mask-size:contain}"],
        changeDetection: 0
      });
    }
  }
  return IconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const BadgeImports = [CommonModule, TuiBadge, IconComponent, TuiStatus, EqualPipe];
let BadgeComponent = /*#__PURE__*/(() => {
  class BadgeComponent {
    constructor() {
      // * Props
      this.cssClasses = computed(() => {
        return {
          [`badge--${this.appearance()}`]: true
        };
      });
      // * Inputs
      this.value = input.required();
      this.type = input(null);
      this.icon = input(null);
      this.appearance = input('default');
      this.size = input('l');
    }
    static {
      this.ɵfac = function BadgeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BadgeComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BadgeComponent,
        selectors: [["assets-badge"]],
        inputs: {
          value: [1, "value"],
          type: [1, "type"],
          icon: [1, "icon"],
          appearance: [1, "appearance"],
          size: [1, "size"]
        },
        decls: 4,
        vars: 4,
        consts: [["appearance", "custom", 1, "badge", "archivo", 3, "ngClass", "size"], [1, "badge-status"], [1, "badge-icon", 3, "badge-icon--s", "icon"], [1, "badge-icon", 3, "icon"]],
        template: function BadgeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "tui-badge", 0);
            i0.ɵɵtemplate(1, BadgeComponent_Case_1_Template, 1, 0, "span", 1)(2, BadgeComponent_Case_2_Template, 2, 6, "assets-icon", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_2_0;
            i0.ɵɵproperty("ngClass", ctx.cssClasses())("size", ctx.size());
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_2_0 = ctx.type()) === "status" ? 1 : tmp_2_0 === "icon" ? 2 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.value(), "\n");
          }
        },
        dependencies: [i1.CommonModule, i1.NgClass, i2.TuiBadge, IconComponent, i4.EqualPipe],
        styles: ["[_nghost-%COMP%]{display:inline-block;height:fit-content}.badge[_ngcontent-%COMP%]{color:var(--assets-text-01)}.badge-icon[_ngcontent-%COMP%]{--assets-icon-component-size: 16px;color:var(--icon-color)}.badge-status[_ngcontent-%COMP%], .badge-icon[_ngcontent-%COMP%]{--icon-color: var(--assets-success-fill)}.badge-status[_ngcontent-%COMP%]{display:inline-block;width:var(--circle-width);height:var(--circle-height);background-color:var(--icon-color);border-radius:50%}.badge--default[_ngcontent-%COMP%]{color:var(--assets-base-01);background-color:var(--assets-primary)}.badge--accent[_ngcontent-%COMP%]{color:var(--assets-base-01);background-color:var(--assets-accent)}.badge--success[_ngcontent-%COMP%]{background-color:var(--assets-success-bg)}.badge--info[_ngcontent-%COMP%]{background-color:var(--assets-info-bg)}.badge--info[_ngcontent-%COMP%]   .badge-status[_ngcontent-%COMP%], .badge--info[_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{--icon-color: var(--assets-info-fill)}.badge--warning[_ngcontent-%COMP%]{background-color:var(--assets-warning-bg)}.badge--warning[_ngcontent-%COMP%]   .badge-status[_ngcontent-%COMP%], .badge--warning[_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{--icon-color: var(--assets-warning-fill)}.badge--error[_ngcontent-%COMP%]{background-color:var(--assets-error-bg)}.badge--error[_ngcontent-%COMP%]   .badge-status[_ngcontent-%COMP%], .badge--error[_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{--icon-color: var(--assets-error-fill)}.badge--clear[_ngcontent-%COMP%]{background-color:var(--assets-neutral-bg)}.badge--clear[_ngcontent-%COMP%]   .badge-status[_ngcontent-%COMP%], .badge--clear[_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{--icon-color: var(--assets-neutral-fill)}.badge--additional[_ngcontent-%COMP%]{background-color:var(--assets-support-22)}.badge--additional[_ngcontent-%COMP%]   .badge-status[_ngcontent-%COMP%], .badge--additional[_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{--icon-color: var(--assets-support-02)}.badge[data-size=xl][_ngcontent-%COMP%]   .badge-status[_ngcontent-%COMP%]{--circle-width: 8px;--circle-height: 8px}.badge[data-size=l][_ngcontent-%COMP%]   .badge-status[_ngcontent-%COMP%]{--circle-width: 6px;--circle-height: 6px}.badge[data-size=m][_ngcontent-%COMP%]   .badge-status[_ngcontent-%COMP%], .badge[data-size=s][_ngcontent-%COMP%]   .badge-status[_ngcontent-%COMP%]{--circle-width: 4px;--circle-height: 4px}.badge[data-size=s][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{--assets-icon-component-size: 12px}"],
        changeDetection: 0
      });
    }
  }
  return BadgeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoaderComponent = /*#__PURE__*/(() => {
  class LoaderComponent {
    static {
      this.ɵfac = function LoaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoaderComponent,
        selectors: [["assets-loader"]],
        decls: 5,
        vars: 0,
        consts: [[1, "loader"]],
        template: function LoaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div")(2, "div")(3, "div")(4, "div");
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [CommonModule],
        styles: [".loader[_ngcontent-%COMP%]{display:flex;gap:6px;align-items:center;justify-content:center;height:35px}.loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{width:16px;height:16px;animation:_ngcontent-%COMP%_anim 1s infinite linear;animation-delay:calc(-.3s * var(--i))}.loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:first-child{--i: 1;background-color:var(--assets-loader-primary, var(--assets-primary));border-radius:0 50% 0 0}.loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(2){--i: 2;background-color:var(--assets-loader-accent, var(--assets-accent));border-radius:50%}.loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(3){--i: 3;background-color:var(--assets-loader-primary, var(--assets-primary));border-radius:50% 0 0 50%}.loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:last-child{--i: 4;background-color:var(--assets-loader-primary, var(--assets-primary));border-radius:50% 50% 0 0}@keyframes _ngcontent-%COMP%_anim{0%,to{transform:translateY(5px)}50%{transform:translateY(-10px)}}"],
        changeDetection: 0
      });
    }
  }
  return LoaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const imports = [IconComponent, LoaderComponent, BadgeComponent];
let AssetsComponentsModule = /*#__PURE__*/(() => {
  class AssetsComponentsModule {
    static {
      this.ɵfac = function AssetsComponentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AssetsComponentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AssetsComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [LoaderComponent, BadgeComponent]
      });
    }
  }
  return AssetsComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AssetsComponentsModule, BadgeComponent, IconComponent, LoaderComponent };
